// extracted by mini-css-extract-plugin
export default {"header":"PageManager_header__2Io+V","containerBg":"PageManager_containerBg__iXc8T"};